"use client"
import { sendBlockEvent } from "@/utils/gtm"
import { replaceRichTextLinks } from "@/utils/replaceRichTextLinks"
import styled from "@emotion/styled"
import { Box, Typography } from "@mui/material"
import React from "react"
import { colors, mediaQueries, sizes } from "ui"
import ButtonWithArrow from "ui/common/bit/ButtonWithArrow"
import { getNonUmbracoUrl } from "utils"
import BlockWrapper from "../common/BlockWrapper"

const StyledRichText = styled(Box)`
  p {
    color: inherit;
  }
  a {
    color: inherit;
    text-decoration: underline;
  }
`
const StyledContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "whiteText",
})<{ whiteText: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${sizes.baseDouble};
  color: ${({ whiteText }) => (whiteText ? colors.white : colors.black)};
  h2 {
    color: ${({ whiteText }) => (whiteText ? colors.white : colors.black)};
  }
`
const StyledBlockWrapper = styled(BlockWrapper)`
  ${mediaQueries.desktopM} {
    padding-top: ${sizes.baseTriple};
    min-height: auto;
  }
`

type LobbyHealthExplanationBlockProps = {
  data: any
  id?: string
}
const ColoredBgTextButton: React.FC<LobbyHealthExplanationBlockProps> = ({
  data,
  id,
}) => {
  const { title, text, button, backgroundColor, whiteText } = data
  return (
    <StyledBlockWrapper
      id={id}
      bgColor={
        backgroundColor?.value ? backgroundColor?.value : colors.lighterRed
      }
    >
      <StyledContainer whiteText={whiteText?.value}>
        {title && <Typography variant="h2">{title.value}</Typography>}
        {text && (
          <StyledRichText
            dangerouslySetInnerHTML={{
              __html: replaceRichTextLinks(text.richText),
            }}
          />
        )}
        {button && button.links[0] && (
          <ButtonWithArrow
            href={getNonUmbracoUrl(button.links[0].url)}
            colorPallette="blue"
            variant="elevated"
            onClick={() => {
              sendBlockEvent({
                blockId: id || "",
                title: title?.value,
                componentName: "סטריפ מידע",
                productName:
                  data?.productName || data?.formDefaultInsuranceType,
                actionName: undefined,
                buttonName: button.links[0]?.name,
              })
            }}
          >
            {button.links[0]?.name}
          </ButtonWithArrow>
        )}
      </StyledContainer>
    </StyledBlockWrapper>
  )
}
export default ColoredBgTextButton
